/* PavCon, LLC Proprietary.All rights reserved 2022 */
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpHelperService } from './http-helper.service';

@Injectable({
  providedIn: 'root'
})
export class MajcomService {
  private baseUrl = `${environment.endpoint}common/majcoms`;

  constructor(private httpHelperService: HttpHelperService) {}

  async getMajcoms(): Promise<any> {
    try {
      return await this.httpHelperService.requestPromise(
        'GET',
        `${this.baseUrl}`,
        undefined
      );
    } catch (error) {
      throw error;
    }
  }
}
